import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github, Youtube } from 'lucide-react';
import { footerLinks, site } from '@/data/content';
import BrandIcon from './BrandIcon';
import { useCookieConsent } from './CookieConsent';

export default function Footer() {
  const { openModal } = useCookieConsent();

  return (
    <footer className="relative overflow-hidden border-t border-slate-800 bg-slate-950 text-slate-300">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-500 to-transparent" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center">
              <img
                src="https://pub-cd1cef45e64043a7a35c1713953c8e6a.r2.dev/Media/Zuri_Hub%20logo%20trans.png"
                alt={site.name}
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="mt-4 max-w-sm text-slate-400">{site.tagline}</p>
            <div className="mt-6 flex gap-3">
              <a href={site.twitter} target="_blank" rel="noreferrer" className="rounded-full bg-slate-900 p-2.5 text-slate-400 transition hover:bg-slate-800 hover:text-white" aria-label="X">
                <Twitter className="h-5 w-5" />
              </a>
              <a href={site.linkedin} target="_blank" rel="noreferrer" className="rounded-full bg-slate-900 p-2.5 text-slate-400 transition hover:bg-slate-800 hover:text-white" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href={site.github} target="_blank" rel="noreferrer" className="rounded-full bg-slate-900 p-2.5 text-slate-400 transition hover:bg-slate-800 hover:text-white" aria-label="GitHub">
                <Github className="h-5 w-5" />
              </a>
              <a href={site.youtube} target="_blank" rel="noreferrer" className="rounded-full bg-slate-900 p-2.5 text-slate-400 transition hover:bg-slate-800 hover:text-white" aria-label="YouTube">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/50 px-3 py-1.5 text-xs font-semibold text-white">
                <BrandIcon name="Meta" className="h-4 w-4" /> Meta Business Partner
              </span>
              <span className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/50 px-3 py-1.5 text-xs font-semibold text-white">
                <BrandIcon name="GoogleCloud" className="h-4 w-4" /> Google Cloud Partner
              </span>
            </div>
          </div>

          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-500">{group}</h4>
              <ul className="mt-5 space-y-3">
                {links.map((link) => (
                  <li key={link.path + link.label}>
                    {link.path === '/cookie-notice' ? (
                      <button
                        onClick={openModal}
                        className="text-sm text-slate-400 transition hover:text-white"
                      >
                        {link.label}
                      </button>
                    ) : link.path.startsWith('http') ? (
                      <a
                        href={link.path}
                        target="_blank"
                        rel="noreferrer"
                        className="text-sm text-slate-400 transition hover:text-white"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link to={link.path} className="text-sm text-slate-400 transition hover:text-white">
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-slate-900 pt-8 text-sm text-slate-500 sm:flex-row">
          <p>
            © {new Date().getFullYear()} {site.name}. All rights reserved. A product of{' '}
            <span className="text-slate-400">Zurichat Technology Company Limited</span>.
          </p>
          <div className="flex gap-6">
            <Link to="/terms" className="hover:text-slate-300">Terms</Link>
            <Link to="/privacy" className="hover:text-slate-300">Privacy</Link>
            <Link to="/cookie-notice" className="hover:text-slate-300">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
